import Billing from './Billing.vue';

export default Billing;
